module.exports = __webpack_public_path__ + "static/media/profile_avatar.b786f44d.svg";